import { render, staticRenderFns } from "./PuntosPeligroControl.vue?vue&type=template&id=21f20196&scoped=true"
import script from "./PuntosPeligroControl.vue?vue&type=script&lang=ts"
export * from "./PuntosPeligroControl.vue?vue&type=script&lang=ts"
import style0 from "./PuntosPeligroControl.vue?vue&type=style&index=0&id=21f20196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f20196",
  null
  
)

export default component.exports